import haxe from "refractor/haxe";
export default haxe;